// this is the dashpord reducer
import { SELECTED_OPTIONS, POPUP_LOC } from "../actions/DashboardActions";
const initialState = {
  selectedOptions: [],
  loc: null
};

const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case SELECTED_OPTIONS:
      return {
        ...state,
        selectedOptions: action.value
      };
    case POPUP_LOC:
      return {
        ...state,
        loc: action.value
      };
    default:
      return state;
  }
};
export default homeReducer;
